<template>
  <div>
    <van-dialog
      v-model="show"
      title=""
      cancel-button-text="再考虑一下"
      confirm-button-text="坚持取消"
      confirm-button-color="#3399FF"
      cancel-button-color="#383838"
      :show-cancel-button="true"
      style="width: 6rem; border-radius: 0.24rem"
      :before-close="beforeClose"
    >
      <div class="wrapper">
        <div class="content">
          <div class="title">确定取消订单？</div>
          <a
            href="tel:4000026862"
            style="color: #3399ff"
          >联系客服</a>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { carLifeOrderCancel } from '@/common/api.js';
import { Toast } from 'vant';

export default {
  name: 'CancelOrder',
  data() {
    return {
      show: false
    };
  },
  props: {
    orderType: {
      type: String,
      default: ''
    }
  },
  methods: {
    init({ orderId }) {
      this.orderId = orderId;
      this.show = true;
    },
    async beforeClose(action, done) {
      // 点击事件 - 备注按钮提示框
      if (action === 'confirm') {
        try {
          await carLifeOrderCancel({ orderNo: this.orderId });
          this.show = false;
          this.$emit('cancelClick');
        } catch (error) {}
        done();
      } else if (action === 'cancel') {
        done(); // 关闭提示框
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.content {
  width: 6rem;
  background-color: #fff;
  border-radius: 0.24rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  font-size: 0.32rem;
  color: #383838;
  padding-bottom: 0.48rem;

  .title {
    padding-top: 0.72rem;
    padding-bottom: 0.48rem;
  }
}
</style>
